@use '@fukuri-admins/ui/layout' as *;

.wrapper {
  display: flex;
  flex-direction: column;
  gap: spacing('8');
  width: 100%;
}

// ファイルリスト（type='file' 時に DropZone の下に表示）
.fileList {
  display: flex;
  flex-direction: column;
  gap: spacing('8');
  list-style: none;
  margin: 0;
  padding: 0;
}

// バリデーションエラーメッセージ
.error {
  @include typography('Jp/12_W3');
  color: text('Red');
  margin: 0;
}
